import { NestingQualification } from '../../../shared/interfaces/quota-nesting.interface';
import {
  IndividualQuota,
  NestedQuota,
} from '../../../shared/interfaces/quota.interface';
import { NestedQuotaCombinedKeyBuilder } from './nested-quota-combine-key-builder';

interface IndividualQuotaBuild {
  build(): IndividualQuota[];
}
export class IndividualQuotaBuilder implements IndividualQuotaBuild {
  constructor(
    private readonly _selectedNestedQuotas: NestedQuota[],
    private readonly _selectedQualifications: NestingQualification[]
  ) {}

  public build(): IndividualQuota[] {
    return this._selectedNestedQuotas.map((selectedNestedQuota) =>
      this._each(selectedNestedQuota)
    );
  }

  private _each(selectedNestedQuota: NestedQuota): IndividualQuota {
    const { required_count, criteria } = selectedNestedQuota;
    return {
      required_count,
      combinedKey: this._combinedKey(selectedNestedQuota),
      allocation: this._allocation(selectedNestedQuota),
      criteria,
    };
  }

  private _combinedKey(selectedNestedQuota: NestedQuota): string[] {
    return new NestedQuotaCombinedKeyBuilder(
      selectedNestedQuota.criteria,
      this._selectedQualifications
    ).build();
  }

  private _allocation(
    selectedNestedQuota: NestedQuota
  ): IndividualQuota['allocation'] {
    return {
      quantity: this._quantity(selectedNestedQuota),
      min: this._minimum(selectedNestedQuota),
      max: this._maximum(selectedNestedQuota),
      percentage: this._percentage(selectedNestedQuota),
      fielded: this._fielded(selectedNestedQuota),
    };
  }

  private _quantity(selectedNestedQuota: NestedQuota): number {
    return (
      selectedNestedQuota.required_count || selectedNestedQuota.number || 0
    );
  }

  private _minimum(selectedNestedQuota: NestedQuota): number {
    return selectedNestedQuota.minimum || 0;
  }

  private _maximum(selectedNestedQuota: NestedQuota): number {
    return selectedNestedQuota.maximum || 0;
  }

  private _percentage(selectedNestedQuota: NestedQuota): number {
    return selectedNestedQuota.percentage || 0;
  }

  private _fielded(selectedNestedQuota: NestedQuota): number {
    return selectedNestedQuota.fielded || 0;
  }
}
